
import { CdFdTaskTypes } from "../CdFdTaskTypes";
import { CdFdProcessHelper } from "../CdFdProcessHelper";

export class CdDevelopmentScenarioSharedHelper {    
    
    static ApprovementRoles = 
    {
        VicePresidentID : "207ff7be-1725-4051-86e3-9ae95fb40ecf",
        VicePresidentName : "Вице-президент"
    };

    static Countries = 
    {
        RussiaID : "6293CC80-C7C1-4A2C-BE40-5F559BB9A60D",
        RussiaGuid1c : "215d0c81-effa-4108-8ce4-d57185730a3b",
        RussiaName : "Вице-президент"
    };

    static CheckFileCategoryList = []; // не проверяем наличие файла ДС #63196

    static ExcludeRolesFromCheckList = [CdDevelopmentScenarioSharedHelper.ApprovementRoles.VicePresidentID]; 

    static ApproverTaskStoreInfo =
    {
        TaskStartProcessOptionsList: [CdFdProcessHelper.ForApproval,CdFdProcessHelper.SendForResubscription],    
        TaskStartProcessTypesList : [CdFdTaskTypes.PkDevelopmentScenarioInitializingTypeID,CdFdTaskTypes.PkDevelopmentScenarioToReworkTypeID]  
    }
}

